// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__CPrPv","text":"Sidebar_text__G5JsK","logo":"Sidebar_logo__rFcjn"};